module.exports = __webpack_public_path__ + "static/img/shopLogo.7b9cf49.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shopLogo.png
// module id = Ty83
// module chunks = 1